// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * True axonometric geometry — no perspective anywhere.
 *
 *   rotate(-30deg) skewX(30deg) scaleY(0.864) == matrix(0.866, -0.5, 0.866, 0.5)
 *
 * Local +x maps to screen (0.866, -0.5) (up-right at 30deg); local +y maps to
 * (0.866, 0.5) (down-right at 30deg). Both card edges land on exactly +/-30deg
 * and the projected bounding box of a card works out to 1.71 : 1.
 *
 * Consequence used below: to shift something straight DOWN the screen by d,
 * the local translation must be (-d, +d) — that is the extruded side face.
 *
 * LAYOUT MODEL
 * .viewport  page-facing box; only its aspect changes across breakpoints
 * .field     tight box around the FULL extent (deck + lifted ghost), centred
 *            in the viewport and sized off its height, so the composition
 *            grows/shrinks as one unit without ever clipping
 * .stage     the animated layer inside the field
 *
 * Every constant below is measured off the reference layout (1-04) in its 3636x2527
 * canvas and re-based onto the field (full extent = 309,-522 -> 3358,2175):
 *   field aspect 1.1225 | card 54.7cqw wide, aspect 1.5652, 3.03cqw extrude
 *   chips 15.28cqw square, 2.72cqw extrude | ghost lifted 86% of card height
 */

.IsometricShowcase_root__EiGhp {
  --iso-viewport-aspect: 1.3;
  --iso-fill: 94%;

  --iso-card-aspect: 1.5652;
  --iso-card-width: 54.7cqw;
  --iso-radius: 3.54cqw;
  --iso-extrude: 3.03cqw;
  --iso-lift: 86%;

  --iso-chip-size: 15.28cqw;
  --iso-chip-radius: 2.53cqw;
  --iso-chip-extrude: 2.72cqw;
  --iso-chip-face: linear-gradient(146deg, #2f7dff 0%, #0a64f9 52%, #0b4fd6 100%);
  --iso-chip-side: #1a1a6b;

  --iso-ghost: rgba(255, 255, 255, 0.62);
  --iso-ghost-fill: rgba(255, 255, 255, 0.03);
  --iso-link: rgba(140, 194, 255, 0.72);

  --iso-control-fg: #ffffff;
  --iso-control-bg: rgba(11, 44, 90, 0.55);
  --iso-control-border: rgba(255, 255, 255, 0.22);

  position: relative;
  width: 100%;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
  letter-spacing: -0.01em;
}

.IsometricShowcase_backgroundTransparent__Z\\+zSw {
  background: transparent;
}

.IsometricShowcase_backgroundLight__TaeMl {
  --iso-ghost: rgba(11, 44, 90, 0.55);
  --iso-ghost-fill: rgba(11, 44, 90, 0.03);
  --iso-link: rgba(10, 100, 249, 0.55);
  --iso-control-fg: #0b2c5a;
  --iso-control-bg: rgba(11, 44, 90, 0.08);
  --iso-control-border: rgba(11, 44, 90, 0.16);
  background: #ffffff;
}

.IsometricShowcase_backgroundDark__qpIM4 {
  background: #0b0b0f;
}

.IsometricShowcase_viewport__sK3gC {
  position: relative;
  width: 100%;
  aspect-ratio: var(--iso-viewport-aspect);
  overflow: hidden;
}

.IsometricShowcase_staticViewport__pS17E {
  position: relative;
  display: grid;
  width: 100%;
  aspect-ratio: var(--iso-viewport-aspect);
  place-items: center;
  overflow: hidden;
}

.IsometricShowcase_staticPoster__hRAqK {
  display: block;
  width: 88%;
  max-width: 88%;
  height: 88%;
  object-fit: contain;
  object-position: center;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

/*
 * Sized off the viewport HEIGHT so the whole composition scales as one unit
 * and always fits, whatever aspect the page gives it. It is also the query
 * container, so every cqw below is 1% of the composition's own width.
 */
.IsometricShowcase_field__xiNhP {
  position: absolute;
  top: 50%;
  left: 50%;
  /*
   * Width is stated explicitly rather than derived from the height via
   * aspect-ratio: an inline-size container must be able to resolve its own
   * inline size without consulting its contents, and engines disagree about
   * the height -> aspect-ratio -> width path under that containment.
   * fill% of viewport height, converted to a share of viewport width.
   */
  width: calc(
    var(--iso-fill) / var(--iso-viewport-aspect) * 1.1225
  );
  height: auto;
  aspect-ratio: 1.1225;
  transform: translate(-50%, -50%);
  container-type: inline-size;
}

.IsometricShowcase_stage__uMiki {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(0.4);
  transform-origin: 53.74% 58.92%;
}

.IsometricShowcase_links__OQG\\+f {
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
}

/*
 * Drawn by moving the line's end point (see applyFrame), not by animating a
 * dash offset — dash geometry is not dependable alongside non-scaling-stroke
 * and a preserveAspectRatio="none" viewBox.
 */
.IsometricShowcase_link__YIgnL {
  stroke: var(--iso-link);
  stroke-width: 1.4;
  stroke-linecap: round;
}

/*
 * A slot lives in screen space and owns every animated value (slide + fade).
 * The isometric projection sits one level down on .slab, so the slide stays
 * vertical on screen instead of travelling along the plane.
 */
.IsometricShowcase_slot__MdLbO {
  position: absolute;
  top: 58.92%;
  left: 53.74%;
  z-index: 3;
  width: var(--iso-card-width);
  aspect-ratio: var(--iso-card-aspect);
  opacity: 0;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.IsometricShowcase_ghostSlot__89txD {
  z-index: 4;
  transform: translate(-50%, -50%) translateY(calc(-1 * var(--iso-lift)));
}

.IsometricShowcase_slab__t8JZi {
  position: absolute;
  inset: 0;
  transform: rotate(-30deg) skewX(30deg) scaleY(0.864);
  transform-origin: 50% 50%;
}

/*
 * Extruded side face: one rounded rect pushed straight down the screen, with
 * box-shadow copies marching back up toward the face so the slab reads solid
 * rather than as a floating rim. Offsets derive from --iso-extrude, so the
 * fill can never overshoot the face when the depth changes.
 */
.IsometricShowcase_side__1UVuH {
  position: absolute;
  inset: 0;
  border-radius: var(--iso-radius);
  background: var(--iso-side-color);
  transform: translate(calc(-1 * var(--iso-extrude)), var(--iso-extrude));
  box-shadow:
    calc(var(--iso-extrude) * 0.125) calc(var(--iso-extrude) * -0.125) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.25) calc(var(--iso-extrude) * -0.25) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.375) calc(var(--iso-extrude) * -0.375) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.5) calc(var(--iso-extrude) * -0.5) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.625) calc(var(--iso-extrude) * -0.625) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.75) calc(var(--iso-extrude) * -0.75) 0 var(--iso-side-color),
    calc(var(--iso-extrude) * 0.875) calc(var(--iso-extrude) * -0.875) 0 var(--iso-side-color);
}

.IsometricShowcase_face__NGj3B {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--iso-radius);
  object-fit: contain;
  -webkit-user-select: none;
  user-select: none;
}

.IsometricShowcase_ghostFace__x1vjf {
  position: absolute;
  inset: 0;
  border: 1px solid var(--iso-ghost);
  border-radius: var(--iso-radius);
  /* Barely-there fill so the 1px stroke still reads once the plane shears it. */
  background: var(--iso-ghost-fill);
}

/* ---- static labelled channel chips ---- */

/*
 * Below the deck (z 3/4): the arriving card travels down through the WEBSITE
 * chip's area, and it must pass in front of it rather than be clipped by it.
 */
.IsometricShowcase_chip__nid\\+H {
  position: absolute;
  z-index: 2;
  width: var(--iso-chip-size);
  aspect-ratio: 1;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.IsometricShowcase_chipSlab__OMYPJ {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--iso-chip-radius);
  background: var(--iso-chip-face);
  transform: rotate(-30deg) skewX(30deg) scaleY(0.864);
  transform-origin: 50% 50%;
  box-shadow:
    calc(var(--iso-chip-extrude) * -0.14) calc(var(--iso-chip-extrude) * 0.14) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -0.28) calc(var(--iso-chip-extrude) * 0.28) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -0.42) calc(var(--iso-chip-extrude) * 0.42) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -0.56) calc(var(--iso-chip-extrude) * 0.56) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -0.7) calc(var(--iso-chip-extrude) * 0.7) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -0.85) calc(var(--iso-chip-extrude) * 0.85) 0 var(--iso-chip-side),
    calc(var(--iso-chip-extrude) * -1) calc(var(--iso-chip-extrude) * 1) 0 var(--iso-chip-side);
}

/*
 * --iso-chip-font is set per chip from its label length so long words stay
 * inside the slab whatever font actually resolves.
 */
.IsometricShowcase_chipLabel__wc4IN {
  max-width: 100%;
  overflow: hidden;
  color: #fff;
  font-size: var(--iso-chip-font);
  font-weight: 800;
  letter-spacing: 0.01em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
}

/* ---- controls ---- */

.IsometricShowcase_controls__M-Qqv {
  position: absolute;
  right: 10px;
  bottom: 8px;
  z-index: 6;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid var(--iso-control-border);
  border-radius: 999px;
  background: var(--iso-control-bg);
  color: var(--iso-control-fg);
  opacity: 0.25;
  backdrop-filter: blur(6px);
  transition: opacity 220ms ease;
}

.IsometricShowcase_root__EiGhp:hover .IsometricShowcase_controls__M-Qqv,
.IsometricShowcase_root__EiGhp:focus-within .IsometricShowcase_controls__M-Qqv {
  opacity: 1;
}

.IsometricShowcase_controlButton__dKqIm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 24px;
  padding: 0 8px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
}

.IsometricShowcase_controlButton__dKqIm:hover {
  background: rgba(10, 100, 249, 0.18);
}

.IsometricShowcase_controlButton__dKqIm:focus-visible {
  outline: 2px solid #0a64f9;
  outline-offset: 1px;
}

.IsometricShowcase_scrub__B8eHi {
  width: 96px;
  height: 3px;
  margin: 0;
  accent-color: #0a64f9;
  cursor: pointer;
}

.IsometricShowcase_scrub__B8eHi:focus-visible {
  outline: 2px solid #0a64f9;
  outline-offset: 3px;
}

.IsometricShowcase_visuallyHidden__PiIos {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* Engines without container query units: fall back to viewport-relative sizes. */
/*
 * Container query units are Chrome/Edge 105+, Safari 16+, Firefox 110+,
 * Opera 91+. Older engines get a proportional fallback: .slot and .chip are
 * children of .stage, which is inset:0 on .field, so plain percentages resolve
 * against exactly the same box that cqw does. Only the depth/radius values —
 * which land in transforms and box-shadows where percentages mean something
 * else — have to approximate with vw.
 */
/*
 * Progressively smaller as the column narrows. The field's share of the column
 * is fill / aspect * 1.1225, so both values move together:
 *   desktop 81.7%  ->  tablet 77.6%  ->  phone 72.7%  ->  small phone 68.1%
 */
@media (max-width: 960px) {
  .IsometricShowcase_root__EiGhp {
    --iso-viewport-aspect: 1.34;
    --iso-fill: 92%;
    --iso-chip-size: 17.5cqw;
  }
}

/*
 * The labels must stay readable at every width, and their shared size is set
 * by the longest one ("DASHBOARD", 9 characters). At the reference chip size
 * the font would fall to ~4px here, so the chips themselves grow instead — a
 * deliberate step away from the reference proportions, traded for legibility.
 */
@media (max-width: 600px) {
  .IsometricShowcase_root__EiGhp {
    --iso-viewport-aspect: 1.32;
    --iso-fill: 88%;
    --iso-chip-size: 23cqw;
  }

  .IsometricShowcase_scrub__B8eHi {
    width: 64px;
  }
}

@media (max-width: 400px) {
  .IsometricShowcase_root__EiGhp {
    --iso-viewport-aspect: 1.3;
    --iso-fill: 85%;
    --iso-chip-size: 27cqw;
  }

  .IsometricShowcase_controls__M-Qqv {
    right: 6px;
    bottom: 4px;
    gap: 5px;
    padding: 4px 6px;
  }

  .IsometricShowcase_scrub__B8eHi {
    width: 48px;
  }
}

/*
 * Container query units are Chrome/Edge 105+, Safari 16+, Firefox 110+,
 * Opera 91+. Older engines get a proportional fallback: .slot and .chip are
 * children of .stage, which is inset:0 on .field, so plain percentages resolve
 * against exactly the same box that cqw does. Only the depth/radius values —
 * which land in transforms and box-shadows where percentages mean something
 * else — have to approximate with vw.
 *
 * This block sits LAST on purpose. The breakpoints above set --iso-chip-size
 * in cqw; on an engine without cqw that value is invalid at computed-value
 * time and the chip would collapse to width:auto, so the percentage ladder
 * here has to override it — which needs equal specificity and later source
 * order.
 */
@supports not (width: 1cqw) {
  .IsometricShowcase_field__xiNhP {
    width: calc(var(--iso-fill) / var(--iso-viewport-aspect) * 1.1225);
  }

  .IsometricShowcase_root__EiGhp {
    --iso-card-width: 54.7%;
    --iso-chip-size: 15.28%;
    --iso-radius: 1.5vw;
    --iso-extrude: 1.3vw;
    --iso-chip-radius: 1.05vw;
    --iso-chip-extrude: 1.15vw;
  }

  @media (max-width: 960px) {
    .IsometricShowcase_root__EiGhp {
      --iso-chip-size: 17.5%;
    }
  }

  @media (max-width: 600px) {
    .IsometricShowcase_root__EiGhp {
      --iso-chip-size: 23%;
    }
  }

  @media (max-width: 400px) {
    .IsometricShowcase_root__EiGhp {
      --iso-chip-size: 27%;
    }
  }

  /* --iso-chip-font is derived from --iso-chip-size, which is no longer a
     length here, so pin the label size directly. */
  .IsometricShowcase_chipLabel__wc4IN {
    font-size: clamp(8px, 1.05vw, 13px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/IsometricShowcase/IsometricShowcase.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;EAuBE;;AAEF;EACE,0BAA0B;EAC1B,eAAe;;EAEf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;;EAEf,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,+EAA+E;EAC/E,wBAAwB;;EAExB,sCAAsC;EACtC,2CAA2C;EAC3C,qCAAqC;;EAErC,yBAAyB;EACzB,wCAAwC;EACxC,+CAA+C;;EAE/C,kBAAkB;EAClB,WAAW;EACX;;;;;;cAMY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;EACxC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT;;;;;;IAME;EACF;;GAEC;EACD,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;EAIE;AACF;EACE,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,oCAAoC;EACpC,UAAU;EACV,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;;;;EAKE;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,iCAAiC;EACjC,uEAAuE;EACvE;;;;;;;8FAO4F;AAC9F;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,gCAAgC;EAChC,8EAA8E;EAC9E,iCAAiC;AACnC;;AAEA,4CAA4C;;AAE5C;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,gCAAgC;EAChC,oDAAoD;EACpD,yBAAyB;EACzB;;;;;;;+FAO6F;AAC/F;;AAEA;;;EAGE;AACF;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;EAC5B,aAAa;EAEb,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iFAAiF;AACjF;;;;;;;EAOE;AACF;;;;EAIE;AACF;EACE;IACE,2BAA2B;IAC3B,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;;;;;EAKE;AACF;EACE;IACE,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;;;;;;;;;;EAaE;AACF;EACE;IACE,kEAAkE;EACpE;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;EACF;;EAEA;mDACiD;EACjD;IACE,mCAAmC;EACrC;AACF","sourcesContent":["/*\n * True axonometric geometry — no perspective anywhere.\n *\n *   rotate(-30deg) skewX(30deg) scaleY(0.864) == matrix(0.866, -0.5, 0.866, 0.5)\n *\n * Local +x maps to screen (0.866, -0.5) (up-right at 30deg); local +y maps to\n * (0.866, 0.5) (down-right at 30deg). Both card edges land on exactly +/-30deg\n * and the projected bounding box of a card works out to 1.71 : 1.\n *\n * Consequence used below: to shift something straight DOWN the screen by d,\n * the local translation must be (-d, +d) — that is the extruded side face.\n *\n * LAYOUT MODEL\n * .viewport  page-facing box; only its aspect changes across breakpoints\n * .field     tight box around the FULL extent (deck + lifted ghost), centred\n *            in the viewport and sized off its height, so the composition\n *            grows/shrinks as one unit without ever clipping\n * .stage     the animated layer inside the field\n *\n * Every constant below is measured off the reference layout (1-04) in its 3636x2527\n * canvas and re-based onto the field (full extent = 309,-522 -> 3358,2175):\n *   field aspect 1.1225 | card 54.7cqw wide, aspect 1.5652, 3.03cqw extrude\n *   chips 15.28cqw square, 2.72cqw extrude | ghost lifted 86% of card height\n */\n\n.root {\n  --iso-viewport-aspect: 1.3;\n  --iso-fill: 94%;\n\n  --iso-card-aspect: 1.5652;\n  --iso-card-width: 54.7cqw;\n  --iso-radius: 3.54cqw;\n  --iso-extrude: 3.03cqw;\n  --iso-lift: 86%;\n\n  --iso-chip-size: 15.28cqw;\n  --iso-chip-radius: 2.53cqw;\n  --iso-chip-extrude: 2.72cqw;\n  --iso-chip-face: linear-gradient(146deg, #2f7dff 0%, #0a64f9 52%, #0b4fd6 100%);\n  --iso-chip-side: #1a1a6b;\n\n  --iso-ghost: rgba(255, 255, 255, 0.62);\n  --iso-ghost-fill: rgba(255, 255, 255, 0.03);\n  --iso-link: rgba(140, 194, 255, 0.72);\n\n  --iso-control-fg: #ffffff;\n  --iso-control-bg: rgba(11, 44, 90, 0.55);\n  --iso-control-border: rgba(255, 255, 255, 0.22);\n\n  position: relative;\n  width: 100%;\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    sans-serif;\n  letter-spacing: -0.01em;\n}\n\n.backgroundTransparent {\n  background: transparent;\n}\n\n.backgroundLight {\n  --iso-ghost: rgba(11, 44, 90, 0.55);\n  --iso-ghost-fill: rgba(11, 44, 90, 0.03);\n  --iso-link: rgba(10, 100, 249, 0.55);\n  --iso-control-fg: #0b2c5a;\n  --iso-control-bg: rgba(11, 44, 90, 0.08);\n  --iso-control-border: rgba(11, 44, 90, 0.16);\n  background: #ffffff;\n}\n\n.backgroundDark {\n  background: #0b0b0f;\n}\n\n.viewport {\n  position: relative;\n  width: 100%;\n  aspect-ratio: var(--iso-viewport-aspect);\n  overflow: hidden;\n}\n\n.staticViewport {\n  position: relative;\n  display: grid;\n  width: 100%;\n  aspect-ratio: var(--iso-viewport-aspect);\n  place-items: center;\n  overflow: hidden;\n}\n\n.staticPoster {\n  display: block;\n  width: 88%;\n  max-width: 88%;\n  height: 88%;\n  object-fit: contain;\n  object-position: center;\n  pointer-events: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/*\n * Sized off the viewport HEIGHT so the whole composition scales as one unit\n * and always fits, whatever aspect the page gives it. It is also the query\n * container, so every cqw below is 1% of the composition's own width.\n */\n.field {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  /*\n   * Width is stated explicitly rather than derived from the height via\n   * aspect-ratio: an inline-size container must be able to resolve its own\n   * inline size without consulting its contents, and engines disagree about\n   * the height -> aspect-ratio -> width path under that containment.\n   * fill% of viewport height, converted to a share of viewport width.\n   */\n  width: calc(\n    var(--iso-fill) / var(--iso-viewport-aspect) * 1.1225\n  );\n  height: auto;\n  aspect-ratio: 1.1225;\n  transform: translate(-50%, -50%);\n  container-type: inline-size;\n}\n\n.stage {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transform: scale(0.4);\n  transform-origin: 53.74% 58.92%;\n}\n\n.links {\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  pointer-events: none;\n}\n\n/*\n * Drawn by moving the line's end point (see applyFrame), not by animating a\n * dash offset — dash geometry is not dependable alongside non-scaling-stroke\n * and a preserveAspectRatio=\"none\" viewBox.\n */\n.link {\n  stroke: var(--iso-link);\n  stroke-width: 1.4;\n  stroke-linecap: round;\n}\n\n/*\n * A slot lives in screen space and owns every animated value (slide + fade).\n * The isometric projection sits one level down on .slab, so the slide stays\n * vertical on screen instead of travelling along the plane.\n */\n.slot {\n  position: absolute;\n  top: 58.92%;\n  left: 53.74%;\n  z-index: 3;\n  width: var(--iso-card-width);\n  aspect-ratio: var(--iso-card-aspect);\n  opacity: 0;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.ghostSlot {\n  z-index: 4;\n  transform: translate(-50%, -50%) translateY(calc(-1 * var(--iso-lift)));\n}\n\n.slab {\n  position: absolute;\n  inset: 0;\n  transform: rotate(-30deg) skewX(30deg) scaleY(0.864);\n  transform-origin: 50% 50%;\n}\n\n/*\n * Extruded side face: one rounded rect pushed straight down the screen, with\n * box-shadow copies marching back up toward the face so the slab reads solid\n * rather than as a floating rim. Offsets derive from --iso-extrude, so the\n * fill can never overshoot the face when the depth changes.\n */\n.side {\n  position: absolute;\n  inset: 0;\n  border-radius: var(--iso-radius);\n  background: var(--iso-side-color);\n  transform: translate(calc(-1 * var(--iso-extrude)), var(--iso-extrude));\n  box-shadow:\n    calc(var(--iso-extrude) * 0.125) calc(var(--iso-extrude) * -0.125) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.25) calc(var(--iso-extrude) * -0.25) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.375) calc(var(--iso-extrude) * -0.375) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.5) calc(var(--iso-extrude) * -0.5) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.625) calc(var(--iso-extrude) * -0.625) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.75) calc(var(--iso-extrude) * -0.75) 0 var(--iso-side-color),\n    calc(var(--iso-extrude) * 0.875) calc(var(--iso-extrude) * -0.875) 0 var(--iso-side-color);\n}\n\n.face {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--iso-radius);\n  object-fit: contain;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.ghostFace {\n  position: absolute;\n  inset: 0;\n  border: 1px solid var(--iso-ghost);\n  border-radius: var(--iso-radius);\n  /* Barely-there fill so the 1px stroke still reads once the plane shears it. */\n  background: var(--iso-ghost-fill);\n}\n\n/* ---- static labelled channel chips ---- */\n\n/*\n * Below the deck (z 3/4): the arriving card travels down through the WEBSITE\n * chip's area, and it must pass in front of it rather than be clipped by it.\n */\n.chip {\n  position: absolute;\n  z-index: 2;\n  width: var(--iso-chip-size);\n  aspect-ratio: 1;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.chipSlab {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--iso-chip-radius);\n  background: var(--iso-chip-face);\n  transform: rotate(-30deg) skewX(30deg) scaleY(0.864);\n  transform-origin: 50% 50%;\n  box-shadow:\n    calc(var(--iso-chip-extrude) * -0.14) calc(var(--iso-chip-extrude) * 0.14) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -0.28) calc(var(--iso-chip-extrude) * 0.28) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -0.42) calc(var(--iso-chip-extrude) * 0.42) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -0.56) calc(var(--iso-chip-extrude) * 0.56) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -0.7) calc(var(--iso-chip-extrude) * 0.7) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -0.85) calc(var(--iso-chip-extrude) * 0.85) 0 var(--iso-chip-side),\n    calc(var(--iso-chip-extrude) * -1) calc(var(--iso-chip-extrude) * 1) 0 var(--iso-chip-side);\n}\n\n/*\n * --iso-chip-font is set per chip from its label length so long words stay\n * inside the slab whatever font actually resolves.\n */\n.chipLabel {\n  max-width: 100%;\n  overflow: hidden;\n  color: #fff;\n  font-size: var(--iso-chip-font);\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n/* ---- controls ---- */\n\n.controls {\n  position: absolute;\n  right: 10px;\n  bottom: 8px;\n  z-index: 6;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border: 1px solid var(--iso-control-border);\n  border-radius: 999px;\n  background: var(--iso-control-bg);\n  color: var(--iso-control-fg);\n  opacity: 0.25;\n  -webkit-backdrop-filter: blur(6px);\n  backdrop-filter: blur(6px);\n  transition: opacity 220ms ease;\n}\n\n.root:hover .controls,\n.root:focus-within .controls {\n  opacity: 1;\n}\n\n.controlButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n  height: 24px;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.controlButton:hover {\n  background: rgba(10, 100, 249, 0.18);\n}\n\n.controlButton:focus-visible {\n  outline: 2px solid #0a64f9;\n  outline-offset: 1px;\n}\n\n.scrub {\n  width: 96px;\n  height: 3px;\n  margin: 0;\n  accent-color: #0a64f9;\n  cursor: pointer;\n}\n\n.scrub:focus-visible {\n  outline: 2px solid #0a64f9;\n  outline-offset: 3px;\n}\n\n.visuallyHidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Engines without container query units: fall back to viewport-relative sizes. */\n/*\n * Container query units are Chrome/Edge 105+, Safari 16+, Firefox 110+,\n * Opera 91+. Older engines get a proportional fallback: .slot and .chip are\n * children of .stage, which is inset:0 on .field, so plain percentages resolve\n * against exactly the same box that cqw does. Only the depth/radius values —\n * which land in transforms and box-shadows where percentages mean something\n * else — have to approximate with vw.\n */\n/*\n * Progressively smaller as the column narrows. The field's share of the column\n * is fill / aspect * 1.1225, so both values move together:\n *   desktop 81.7%  ->  tablet 77.6%  ->  phone 72.7%  ->  small phone 68.1%\n */\n@media (max-width: 960px) {\n  .root {\n    --iso-viewport-aspect: 1.34;\n    --iso-fill: 92%;\n    --iso-chip-size: 17.5cqw;\n  }\n}\n\n/*\n * The labels must stay readable at every width, and their shared size is set\n * by the longest one (\"DASHBOARD\", 9 characters). At the reference chip size\n * the font would fall to ~4px here, so the chips themselves grow instead — a\n * deliberate step away from the reference proportions, traded for legibility.\n */\n@media (max-width: 600px) {\n  .root {\n    --iso-viewport-aspect: 1.32;\n    --iso-fill: 88%;\n    --iso-chip-size: 23cqw;\n  }\n\n  .scrub {\n    width: 64px;\n  }\n}\n\n@media (max-width: 400px) {\n  .root {\n    --iso-viewport-aspect: 1.3;\n    --iso-fill: 85%;\n    --iso-chip-size: 27cqw;\n  }\n\n  .controls {\n    right: 6px;\n    bottom: 4px;\n    gap: 5px;\n    padding: 4px 6px;\n  }\n\n  .scrub {\n    width: 48px;\n  }\n}\n\n/*\n * Container query units are Chrome/Edge 105+, Safari 16+, Firefox 110+,\n * Opera 91+. Older engines get a proportional fallback: .slot and .chip are\n * children of .stage, which is inset:0 on .field, so plain percentages resolve\n * against exactly the same box that cqw does. Only the depth/radius values —\n * which land in transforms and box-shadows where percentages mean something\n * else — have to approximate with vw.\n *\n * This block sits LAST on purpose. The breakpoints above set --iso-chip-size\n * in cqw; on an engine without cqw that value is invalid at computed-value\n * time and the chip would collapse to width:auto, so the percentage ladder\n * here has to override it — which needs equal specificity and later source\n * order.\n */\n@supports not (width: 1cqw) {\n  .field {\n    width: calc(var(--iso-fill) / var(--iso-viewport-aspect) * 1.1225);\n  }\n\n  .root {\n    --iso-card-width: 54.7%;\n    --iso-chip-size: 15.28%;\n    --iso-radius: 1.5vw;\n    --iso-extrude: 1.3vw;\n    --iso-chip-radius: 1.05vw;\n    --iso-chip-extrude: 1.15vw;\n  }\n\n  @media (max-width: 960px) {\n    .root {\n      --iso-chip-size: 17.5%;\n    }\n  }\n\n  @media (max-width: 600px) {\n    .root {\n      --iso-chip-size: 23%;\n    }\n  }\n\n  @media (max-width: 400px) {\n    .root {\n      --iso-chip-size: 27%;\n    }\n  }\n\n  /* --iso-chip-font is derived from --iso-chip-size, which is no longer a\n     length here, so pin the label size directly. */\n  .chipLabel {\n    font-size: clamp(8px, 1.05vw, 13px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `IsometricShowcase_root__EiGhp`,
	"backgroundTransparent": `IsometricShowcase_backgroundTransparent__Z+zSw`,
	"backgroundLight": `IsometricShowcase_backgroundLight__TaeMl`,
	"backgroundDark": `IsometricShowcase_backgroundDark__qpIM4`,
	"viewport": `IsometricShowcase_viewport__sK3gC`,
	"staticViewport": `IsometricShowcase_staticViewport__pS17E`,
	"staticPoster": `IsometricShowcase_staticPoster__hRAqK`,
	"field": `IsometricShowcase_field__xiNhP`,
	"stage": `IsometricShowcase_stage__uMiki`,
	"links": `IsometricShowcase_links__OQG+f`,
	"link": `IsometricShowcase_link__YIgnL`,
	"slot": `IsometricShowcase_slot__MdLbO`,
	"ghostSlot": `IsometricShowcase_ghostSlot__89txD`,
	"slab": `IsometricShowcase_slab__t8JZi`,
	"side": `IsometricShowcase_side__1UVuH`,
	"face": `IsometricShowcase_face__NGj3B`,
	"ghostFace": `IsometricShowcase_ghostFace__x1vjf`,
	"chip": `IsometricShowcase_chip__nid+H`,
	"chipSlab": `IsometricShowcase_chipSlab__OMYPJ`,
	"chipLabel": `IsometricShowcase_chipLabel__wc4IN`,
	"controls": `IsometricShowcase_controls__M-Qqv`,
	"controlButton": `IsometricShowcase_controlButton__dKqIm`,
	"scrub": `IsometricShowcase_scrub__B8eHi`,
	"visuallyHidden": `IsometricShowcase_visuallyHidden__PiIos`
};
export default ___CSS_LOADER_EXPORT___;
